import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystacabbookinginpune() {



  const cardData =
  {
    keyword: 'Innova Crysta Cab Booking in Pune',
    heading: 'Sanavi Travels: Innova Crysta Cab Booking in Pune',
    headingDescription: 'Sanavi Travels offers reliable Innova Crysta Cab Booking in Pune, providing safe, comfortable, and premium transportation for families, corporate travelers, tourists, and group commuters within Pune and for outstation trips. Our fleet of Innova Crysta cabs is well-maintained with spacious seating, air-conditioning, ample legroom, and luggage space, ensuring a smooth and luxurious travel experience. With professional chauffeurs, flexible local and outstation cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free service. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular routes and destinations such as Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, Aurangabad, Kolhapur, and Konkan. Choose Sanavi Travels for trusted Innova Crysta cab booking in Pune, delivering comfort, safety, and a premium travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha heritage. Once the seat of Peshwa Bajirao I, it features grand gateways like the Delhi Darwaza, massive stone walls, and lush gardens. Though partially destroyed by fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum with Gandhi’s artifacts, photographs, and historical documents, set amidst sprawling gardens and serene ambiance."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for extensive charitable work, making it Pune’s spiritual heartbeat."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore ancient ramparts, memorials, and viewpoints. The fort offers breathtaking views of the Sahyadri ranges and local cuisine near the summit."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being in the city center, it maintains tranquility and showcases early Indian craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal depicts historical lifestyles and makes the museum invaluable for art and history enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are mesmerizing."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors seek relaxation, rejuvenation, and personal transformation here."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers provide a serene sanctuary. Families, joggers, and photographers enjoy peaceful walks here."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The reservoir and surrounding hills create picturesque scenery, especially during monsoon. Street vendors add charm, and the dam also serves as the gateway to Sinhagad Fort, making it ideal for weekends and family outings."
  }
]
,




"services": [
  {
    "name": "Innova Crysta Cab Booking in Pune",
    "description": "Innova Crysta Cab Booking in Pune offers a convenient way to book premium Innova Crysta cabs for city travel, airport transfers, and outstation trips. Comfortable interiors and professional drivers ensure a smooth and luxurious ride."
  },
  {
    "name": "Innova Crysta Hire Pune",
    "description": "Innova Crysta Hire Pune provides rental services for Innova Crysta vehicles suitable for family trips, corporate travel, and sightseeing. Well-maintained cars with experienced drivers make every journey safe and comfortable."
  },
  {
    "name": "AC Innova Crysta Pune",
    "description": "AC Innova Crysta Pune ensures a cool and comfortable travel experience in Pune. Ideal for long-distance trips or city travel during hot weather, these cabs offer air-conditioned interiors and smooth rides."
  },
  {
    "name": "Luxury Innova Crysta Rental Pune",
    "description": "Luxury Innova Crysta Rental Pune offers premium vehicles for travelers seeking comfort, style, and convenience. Equipped with modern amenities, these cabs are perfect for VIP trips, corporate travel, and special occasions."
  },
  {
    "name": "Outstation Innova Crysta Pune",
    "description": "Outstation Innova Crysta Pune provides safe and comfortable transport for long-distance journeys from Pune to nearby cities and tourist destinations. Professional drivers ensure a stress-free travel experience."
  },
  {
    "name": "Family Innova Crysta Cab Pune",
    "description": "Family Innova Crysta Cab Pune caters to families traveling together, offering spacious seating, ample luggage space, and a safe journey. Ideal for weekend trips, vacations, and city tours."
  },
  {
    "name": "Corporate Innova Crysta Pune",
    "description": "Corporate Innova Crysta Pune serves business travelers with comfortable and punctual cabs. Perfect for office commutes, meetings, and corporate events, ensuring a professional and reliable travel experience."
  },
  {
    "name": "Affordable Innova Crysta Pune",
    "description": "Affordable Innova Crysta Pune offers cost-effective rental options for groups or families without compromising on comfort or safety. Well-maintained vehicles and professional drivers make it an economical choice."
  },
  {
    "name": "Chauffeur Driven Innova Crysta",
    "description": "Chauffeur Driven Innova Crysta provides professional drivers to handle routes and traffic, allowing passengers to relax and enjoy a smooth and hassle-free journey in Pune and beyond."
  },
  {
    "name": "Best Innova Crysta Cab Pune",
    "description": "Best Innova Crysta Cab Pune offers top-quality Innova Crysta vehicles with excellent service, punctuality, and comfort. Ideal for city travel, airport transfers, and long-distance trips."
  },
  {
    "name": "Pune Innova Crysta Taxi",
    "description": "Pune Innova Crysta Taxi provides reliable taxi services using premium Innova Crysta vehicles. Perfect for local travel, airport transfers, and outstation trips, ensuring a safe and enjoyable ride."
  },
  {
    "name": "Airport Innova Crysta Pune",
    "description": "Airport Innova Crysta Pune ensures timely and comfortable pickups and drop-offs at Pune airport. Spacious, luggage-friendly, and air-conditioned vehicles make airport transfers hassle-free."
  },
  {
    "name": "Tourist Innova Crysta Pune",
    "description": "Tourist Innova Crysta Pune caters to travelers exploring Pune and nearby attractions. Comfortable and reliable cabs with experienced drivers make sightseeing and day trips enjoyable and stress-free."
  },
  {
    "name": "Wedding Innova Crysta Pune",
    "description": "Wedding Innova Crysta Pune provides elegant and comfortable vehicles for wedding guests and bridal travel. Professional chauffeurs ensure timely arrivals and a premium travel experience for special occasions."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune offers a hassle-free platform to book Innova Crysta cabs in Pune. Instant booking, professional drivers, and a variety of cab options ensure convenient and reliable travel."
  }
],
"tableData": [
  ["Innova Crysta Cab Booking in Pune", "Innova Crysta Hire Pune"],
  ["AC Innova Crysta Pune", "Luxury Innova Crysta Rental Pune"],
  ["Outstation Innova Crysta Pune", "Family Innova Crysta Cab Pune"],
  ["Corporate Innova Crysta Pune", "Affordable Innova Crysta Pune"],
  ["Chauffeur Driven Innova Crysta", "Best Innova Crysta Cab Pune"],
  ["Pune Innova Crysta Taxi", "Airport Innova Crysta Pune"],
  ["Tourist Innova Crysta Pune", "Wedding Innova Crysta Pune"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Cab Booking in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers convenient and reliable Innova Crysta cab booking services in Pune, perfect for airport transfers, outstation trips, family travel, and corporate rides."
  },
  {
    "WhyChooseheading": "Comfortable and Premium Innova Crysta",
    "WhyChoosedescription": "Travel in a spacious, air‑conditioned, and well‑maintained Innova Crysta for a smooth and luxurious journey in Pune and beyond."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, experienced, and familiar with Pune routes to ensure safe and punctual travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront pricing for Innova Crysta cab bookings, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and real‑time updates."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from local rides, airport transfers, outstation trips, and hourly or daily rentals according to your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Innova Crysta cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Innova Crysta cab booking in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Innova Crysta cab booking in Pune?',
    answer: 'Yes, Sanavi Travels offers comfortable and well‑maintained Innova Crysta cabs for booking in Pune.'
  },
  {
    question: 'How can I book an Innova Crysta cab in Pune?',
    answer: 'You can book easily through the Sanavi Travels website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of trips can I use an Innova Crysta cab for?',
    answer: 'Innova Crysta cabs are suitable for airport transfers, local rides, outstation travel, family trips, and corporate travel.'
  },
  {
    question: 'Are drivers included with the Innova Crysta cab booking?',
    answer: 'Yes, all bookings include experienced and professional drivers.'
  },
  {
    question: 'Is Innova Crysta cab booking available 24x7?',
    answer: 'Yes, our Innova Crysta cab booking service is available round the clock to match your travel schedule.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all Innova Crysta cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off points within Pune or for outstation travel.'
  },
  {
    question: 'What payment options are available for Innova Cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during my journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Innova Crysta cab trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Booked an Innova Crysta cab with Sanavi Travels in Pune. Very comfortable ride and excellent service throughout!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Riya Kulkarni',
    feedback: 'Great experience! The Innova Crysta was clean, the driver was professional, and the trip was smooth and enjoyable.',
    rating: 5
  }
];















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Cab Booking in Pune - Sanavi Travels",
  "description": "Book Innova Crysta cabs in Pune with Sanavi Travels. AC and luxury Innova Crysta for family trips, corporate travel, airport transfers, weddings, outstation journeys, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Innova Crysta Cab Booking in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury Innova Crysta cabs in Pune with Sanavi Travels. Perfect for family trips, corporate travel, airport transfers, weddings, outstation journeys, and chauffeur-driven comfort."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystacabbookinginpune;